(() => {
  const DESKTOP_QUERY = '(min-width: 1024px)';
  const MIN_TOP_OFFSET = 16;
  const HEADER_GAP = 12;

  function initProductMain(productMain) {
    if (!productMain || productMain.dataset.galleryScrollLockInitialized === 'true') return;

    const gallery = productMain.querySelector(':scope > product-gallery.product-gallery');
    const details = productMain.querySelector(':scope > product-details.product-details');
    if (!gallery || !details) return;

    productMain.dataset.galleryScrollLockInitialized = 'true';

    const media = window.matchMedia(DESKTOP_QUERY);
    const headerContainer = document.querySelector('.site-header__container');
    let metrics = null;
    let scrollFrame = null;
    let measureFrame = null;
    let measuring = false;

    const getTopOffset = () => {
      if (!headerContainer) return MIN_TOP_OFFSET;

      const headerRect = headerContainer.getBoundingClientRect();
      const visibleHeaderBottom = Math.max(0, headerRect.bottom);

      return Math.max(MIN_TOP_OFFSET, visibleHeaderBottom + HEADER_GAP);
    };

    const revealAllGalleryItems = () => {
      const hiddenStateClass = gallery.getAttribute('hidden-state-class') || 'hidden-above-tablet';

      gallery.querySelectorAll('[data-ref="item"]').forEach((item) => {
        item.classList.remove(hiddenStateClass);
      });

      const showMoreButton = gallery.querySelector('[data-ref="showMoreButton"]');
      const showMoreWrapper = showMoreButton?.closest('.product-gallery__grid__show-more');

      if (showMoreWrapper) {
        showMoreWrapper.remove();
      } else {
        showMoreButton?.remove();
      }
    };

    const clearDetailStyles = () => {
      details.style.position = 'relative';
      details.style.top = 'auto';
      details.style.left = 'auto';
      details.style.width = '';
      details.style.zIndex = '';
    };

    const resetMobile = () => {
      metrics = null;
      productMain.style.position = '';
      productMain.style.minHeight = '';
      details.style.position = '';
      details.style.top = '';
      details.style.left = '';
      details.style.width = '';
      details.style.zIndex = '';
    };

    const applyState = () => {
      scrollFrame = null;
      if (!media.matches || !metrics) return;

      const y = window.scrollY;
      const topOffset = getTopOffset();
      const start = metrics.mainDocumentTop - topOffset;
      const release = Math.max(
        start,
        metrics.mainDocumentTop + metrics.galleryHeight - (topOffset + metrics.anchorBottomInDetails)
      );

      if (y < start) {
        clearDetailStyles();
        return;
      }

      if (y < release) {
        details.style.position = 'fixed';
        details.style.top = `${topOffset}px`;
        details.style.left = `${metrics.detailsViewportLeft}px`;
        details.style.width = `${metrics.detailsWidth}px`;
        details.style.zIndex = '20';
        return;
      }

      details.style.position = 'absolute';
      details.style.top = `${metrics.detailsAbsoluteTop}px`;
      details.style.left = `${metrics.detailsOffsetLeft}px`;
      details.style.width = `${metrics.detailsWidth}px`;
      details.style.zIndex = '20';
    };

    const measure = () => {
      measureFrame = null;
      if (measuring) return;

      if (!media.matches) {
        resetMobile();
        return;
      }

      measuring = true;

      revealAllGalleryItems();
      productMain.style.position = 'relative';
      productMain.style.minHeight = '';
      clearDetailStyles();

      const mainRect = productMain.getBoundingClientRect();
      const detailsRect = details.getBoundingClientRect();
      const accordion = details.querySelector('.product-details__accordions');
      const accordionRect = accordion?.getBoundingClientRect();
      const galleryHeight = gallery.offsetHeight;
      const detailsHeight = details.offsetHeight;
      const mainDocumentTop = mainRect.top + window.scrollY;

      const anchorBottomInDetails = accordionRect
        ? accordionRect.bottom - detailsRect.top
        : detailsHeight;

      const detailsAbsoluteTop = Math.max(0, galleryHeight - anchorBottomInDetails);

      metrics = {
        mainDocumentTop,
        galleryHeight,
        detailsHeight,
        anchorBottomInDetails,
        detailsAbsoluteTop,
        detailsWidth: detailsRect.width,
        detailsViewportLeft: detailsRect.left,
        detailsOffsetLeft: detailsRect.left - mainRect.left
      };

      productMain.style.minHeight = `${Math.max(
        galleryHeight,
        detailsAbsoluteTop + detailsHeight
      )}px`;

      measuring = false;
      applyState();
    };

    const scheduleMeasure = () => {
      if (measureFrame) cancelAnimationFrame(measureFrame);
      measureFrame = requestAnimationFrame(measure);
    };

    const onScroll = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(applyState);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', scheduleMeasure, { passive: true });

    if (media.addEventListener) {
      media.addEventListener('change', scheduleMeasure);
    } else if (media.addListener) {
      media.addListener(scheduleMeasure);
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        if (!measuring) scheduleMeasure();
      });
      resizeObserver.observe(gallery);
      resizeObserver.observe(details);
    }

    if ('MutationObserver' in window) {
      const detailsMutationObserver = new MutationObserver(scheduleMeasure);
      detailsMutationObserver.observe(details, { childList: true, subtree: true, characterData: true });

      const headerStateObserver = new MutationObserver(onScroll);
      headerStateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    scheduleMeasure();
  }

  function initAll() {
    document.querySelectorAll('.product-main--new-layout').forEach(initProductMain);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

(() => {
  const MOBILE_QUERY = '(max-width: 767px)';
  const STYLE_ID = 'pdp-mobile-refinements';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media screen and (max-width: 767px) {
        .product-main--new-layout {
          row-gap: 0 !important;
        }

        .product-main--new-layout > product-details.product-details {
          gap: 10px !important;
          padding-top: 10px !important;
        }

        .pdp-mobile-product-header {
          display: flex;
          flex-direction: column;
          gap: 3px;
          width: 100%;
          margin: 0 !important;
        }

        .pdp-mobile-product-heading {
          display: flex;
          align-items: center;
          gap: 6px;
          width: 100%;
        }

        .pdp-mobile-product-heading > h1 {
          flex: 0 1 auto;
          margin: 0;
          padding-top: 0 !important;
          font-size: 28px !important;
          line-height: 1.05 !important;
        }

        .pdp-mobile-product-heading > product-card-badges {
          flex: 0 0 auto;
          align-self: center;
          margin: 0 !important;
          transform: translateY(-1px);
        }

        .pdp-mobile-product-heading > product-card-badges badge-element,
        .pdp-mobile-product-heading > product-card-badges .product-card-badges__badge {
          font-size: 10px !important;
          line-height: 1 !important;
        }

        .pdp-mobile-product-header > .width-full {
          margin: 0 !important;
          line-height: 1 !important;
        }

        .product-main--new-layout .product-details__usps-block {
          padding-top: 0 !important;
          padding-bottom: 2px !important;
          margin: 0 !important;
        }

        .product-main--new-layout .product-details__usps-grid {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          column-gap: 12px;
          row-gap: 7px;
        }

        .product-main--new-layout .product-details__usp-item {
          gap: 6px;
          font-size: 12px !important;
          line-height: 1.25;
        }

        .product-main--new-layout .product-details__usp-check {
          flex-basis: 14px;
          width: 14px;
          height: 14px;
          margin-top: 0;
        }

        .product-main--new-layout .multi-buy-widget__item:not(:has(input[data-ref="itemOption"]:checked)) .multi-buy-widget__expanded-content {
          display: none !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .multi-buy-widget__expanded-content {
          display: block !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) {
          padding: 16px 14px 14px !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__header--new {
          display: grid !important;
          grid-template-columns: minmax(0, 1fr) auto !important;
          grid-template-areas:
            "top top"
            "price perday"
            "billing billing" !important;
          gap: 6px 10px !important;
          align-items: center !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__header-top {
          grid-area: top;
          min-width: 0;
          margin: 0 !important;
          padding: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__title-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 7px !important;
          min-height: 24px;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__title {
          line-height: 1.15 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__header-main {
          display: contents !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__monthly-price {
          grid-area: price;
          display: flex !important;
          align-items: baseline !important;
          flex-wrap: wrap !important;
          gap: 5px !important;
          min-width: 0;
          margin: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__compare-price--monthly {
          font-size: 14px !important;
          line-height: 1 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__final-price--monthly {
          font-size: 28px !important;
          line-height: 1 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__per-month {
          font-size: 16px !important;
          line-height: 1 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__price-per-day {
          grid-area: perday;
          justify-self: end;
          margin: 0 !important;
          font-size: 13px !important;
          font-weight: 600;
          line-height: 1.15 !important;
          text-align: right;
          white-space: nowrap;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__billing-row {
          grid-area: billing;
          margin: 0 !important;
          padding: 0 !important;
          line-height: 1.15 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) .multi-buy-widget__item__plan {
          font-size: 12px !important;
          line-height: 1.15 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(.multi-buy-widget__item__header--new) > .multi-buy-widget__item__savings {
          top: -11px !important;
          right: 12px !important;
          padding: 6px 14px !important;
          font-size: 12px !important;
          line-height: 1 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .multi-buy-widget__item__subscription-benefits {
          gap: 8px !important;
          width: calc(100% + 8px);
          margin: 12px -4px 0 !important;
          padding: 12px 0 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .multi-buy-widget__item__benefit {
          margin: 0 !important;
          padding-left: 19px !important;
          font-size: 13px !important;
          line-height: 1.2 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .multi-buy-widget__item__benefit::before {
          content: "✓" !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          box-sizing: border-box !important;
          width: 15px !important;
          height: 15px !important;
          min-width: 15px !important;
          min-height: 15px !important;
          max-width: 15px !important;
          max-height: 15px !important;
          inline-size: 15px !important;
          block-size: 15px !important;
          padding: 0 !important;
          overflow: hidden !important;
          aspect-ratio: 1 / 1;
          border-radius: 50%;
          clip-path: circle(7.5px at 7.5px 7.5px);
          background-color: #ead2c5 !important;
          background-image: none !important;
          color: var(--color-dark-mocha) !important;
          font-family: Arial, sans-serif !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          line-height: 15px !important;
          text-align: center !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__welcome-kit {
          margin: 12px -4px 0 !important;
          padding: 12px 8px 14px !important;
          border-top: 0 !important;
          border-radius: 14px;
          background: rgba(153, 101, 61, .055);
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__section-title {
          display: block !important;
          width: 100%;
          margin: 0 0 10px !important;
          padding: 0 !important;
          font-size: 12px !important;
          line-height: 1.15 !important;
          text-align: center !important;
          white-space: nowrap !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-grid {
          display: flex !important;
          flex-wrap: nowrap !important;
          align-items: flex-start !important;
          justify-content: space-between !important;
          gap: 4px !important;
          width: 100%;
          min-width: 0;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift {
          display: flex !important;
          flex: 1 1 0 !important;
          flex-direction: column !important;
          align-items: center !important;
          gap: 4px !important;
          width: auto !important;
          min-width: 0 !important;
          max-width: none !important;
          margin: 0 !important;
          text-align: center;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-image {
          flex: 0 0 72px !important;
          width: 72px !important;
          height: 72px !important;
          margin: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-image img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-plus {
          display: flex !important;
          flex: 0 0 8px !important;
          align-items: center !important;
          justify-content: center !important;
          width: 8px !important;
          height: 72px !important;
          margin: 0 !important;
          padding: 0 !important;
          font-size: 14px !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-title {
          width: 100%;
          min-width: 0;
          margin: 0 !important;
          font-size: 11px !important;
          line-height: 1.15 !important;
          overflow-wrap: anywhere;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-price {
          margin: 3px 0 0 !important;
          color: rgba(40, 34, 29, .62) !important;
          font-size: 11px !important;
          line-height: 1 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__future-gifts {
          margin: 12px 0 0 !important;
          padding-top: 0 !important;
          border-top: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__future-gifts-summary {
          min-height: 44px !important;
          padding: 9px 12px !important;
          font-size: 13px !important;
          line-height: 1.15 !important;
        }
      }

      @media screen and (min-width: 1024px) {
        .product-main--new-layout {
          box-sizing: border-box;
          column-gap: clamp(24px, 2.5vw, 40px) !important;
          grid-template-columns: minmax(0, 1.25fr) minmax(0, 1fr) !important;
          padding-inline: clamp(24px, 3vw, 48px) !important;
        }

        .product-main--new-layout > product-gallery.product-gallery,
        .product-main--new-layout > product-details.product-details {
          min-width: 0;
        }

        .product-main--new-layout > product-details.product-details {
          box-sizing: border-box;
          gap: 10px !important;
          padding-right: clamp(24px, 3vw, 48px) !important;
        }

        .product-main--new-layout .pdp-mobile-product-header {
          display: flex;
          flex-direction: column;
          gap: 3px;
          width: 100%;
          margin: 0 0 4px !important;
          padding-top: 12px;
        }

        .product-main--new-layout .pdp-mobile-product-heading {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          width: 100%;
        }

        .product-main--new-layout .pdp-mobile-product-heading > h1 {
          flex: 0 1 auto;
          margin: 0 !important;
          line-height: 1.05 !important;
        }

        .product-main--new-layout .pdp-mobile-product-heading > product-card-badges {
          flex: 0 0 auto;
          align-self: flex-start;
          margin: 0 !important;
          transform: translateY(-4px);
        }

        .product-main--new-layout .pdp-mobile-product-header > .width-full {
          margin: 0 !important;
          line-height: 1 !important;
        }

        .product-main--new-layout > product-details.product-details > product-card-badges {
          margin: 0 0 4px !important;
        }

        .product-main--new-layout > product-details.product-details > h1 {
          margin: 0 0 6px !important;
        }

        .product-main--new-layout > product-details.product-details > .width-full {
          margin: 0 0 4px !important;
        }

        .product-main--new-layout .product-details__usps-block {
          margin: 0 0 12px !important;
          padding: 0 !important;
        }

        .product-main--new-layout .product-details__usps-grid {
          column-gap: 20px !important;
          row-gap: 8px !important;
        }

        .product-main--new-layout .product-details__usp-item {
          gap: 7px !important;
          line-height: 1.25 !important;
        }

        .product-main--new-layout .multi-buy-widget {
          gap: 12px !important;
          margin-top: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item {
          padding: 16px !important;
        }

        .product-main--new-layout .multi-buy-widget__item__header--new,
        .product-main--new-layout .multi-buy-widget__item__header-top,
        .product-main--new-layout .multi-buy-widget__item__header-main,
        .product-main--new-layout .multi-buy-widget__item__billing-row {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .multi-buy-widget__item__subscription-benefits {
          gap: 6px 18px !important;
          margin: 0 !important;
          padding: 14px 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .multi-buy-widget__item__benefit {
          margin: 0 !important;
          font-size: 13px !important;
          line-height: 1.2 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__welcome-kit {
          display: block !important;
          margin: 0 !important;
          padding: 12px !important;
          border-top: 0 !important;
          border-bottom: 0 !important;
          border-radius: 12px;
          background: rgba(153, 101, 61, .055);
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__section-title {
          display: block !important;
          width: 100% !important;
          margin: 0 0 10px !important;
          font-size: 13px !important;
          line-height: 1.15 !important;
          text-align: center !important;
          white-space: nowrap !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-grid {
          display: flex !important;
          align-items: flex-start !important;
          justify-content: center !important;
          gap: clamp(18px, 2vw, 30px) !important;
          width: 100% !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift {
          flex: 0 1 170px !important;
          gap: 4px !important;
          min-width: 0 !important;
          text-align: center !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-image {
          width: 72px !important;
          height: 72px !important;
          margin-inline: auto !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-plus {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 72px !important;
          margin: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__gift-title {
          margin: 0 !important;
          line-height: 1.15 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__future-gifts {
          margin: 10px 0 0 !important;
          padding-top: 0 !important;
          border-top: 0 !important;
        }

        .product-main--new-layout .multi-buy-widget__item:has(input[data-ref="itemOption"]:checked) .box-line-item__future-gifts-summary {
          min-height: 42px !important;
          padding: 8px 12px !important;
          line-height: 1.15 !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function getDirectChild(details, predicate) {
    return Array.from(details.children).find(predicate) || null;
  }

  function initMobileHeader(details) {
    if (!details || details.dataset.mobileHeaderInitialized === 'true') return;

    const title = getDirectChild(details, (element) => element.matches('h1'));
    const badges = getDirectChild(details, (element) => element.matches('product-card-badges'));
    const reviews = getDirectChild(details, (element) => element.querySelector('.yotpo-widget-instance'));
    if (!title || !reviews) return;

    details.dataset.mobileHeaderInitialized = 'true';

    const movableElements = [badges, title, reviews].filter(Boolean);
    const placeholders = new Map();
    movableElements.forEach((element) => {
      const placeholder = document.createComment('pdp-mobile-original-position');
      element.before(placeholder);
      placeholders.set(element, placeholder);
    });

    const header = document.createElement('div');
    header.className = 'pdp-mobile-product-header';

    const heading = document.createElement('div');
    heading.className = 'pdp-mobile-product-heading';

    const firstPlaceholder = placeholders.get(movableElements[0]);
    firstPlaceholder.before(header);

    const mobileQuery = window.matchMedia(MOBILE_QUERY);

    const applyLayout = () => {
      if (mobileQuery.matches) {
        header.appendChild(reviews);
        heading.appendChild(title);
        if (badges && badges.querySelector('badge-element, .product-card-badges__badge')) {
          heading.appendChild(badges);
        }
        header.appendChild(heading);
        return;
      }

      header.appendChild(reviews);
      heading.appendChild(title);
      if (badges && badges.querySelector('badge-element, .product-card-badges__badge')) {
        heading.appendChild(badges);
      }
      header.appendChild(heading);
    };

    applyLayout();
    mobileQuery.addEventListener('change', applyLayout);
  }

  function initMobileRefinements() {
    addStyles();
    document.querySelectorAll('.product-main--new-layout').forEach((productMain) => {
      initMobileHeader(productMain.querySelector(':scope > product-details.product-details'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileRefinements, { once: true });
  } else {
    initMobileRefinements();
  }

  document.addEventListener('shopify:section:load', initMobileRefinements);
})();
